import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { post } from "common/helpers/HTTP";
import type { LinkedInProfile } from "common/types";

async function searchProfiles(
  workspaceId: string,
  keyword: string,
): Promise<LinkedInProfile[]> {
  const queryParams = new URLSearchParams();
  queryParams.set("page", "0");
  queryParams.set("count", "50");

  const { targets } = await post(
    `workspaces/${workspaceId}/search?${queryParams.toString()}`,
    {
      keywords: [{ text: keyword, type: "general", modifier: "optional" }],
    },
  );
  return targets;
}

export default function useProfileSearch(keyword: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { profileSearchKeys } = getQueryKeys(workspaceId);

  const { isLoading: isLoadingProfiles, data: profiles } = useQuery({
    queryKey: profileSearchKeys.list(keyword),
    queryFn: () => searchProfiles(workspaceId, keyword),
    enabled: !!keyword,
  });

  return { profiles, isLoadingProfiles };
}
